import React from 'react'
import EditConsumerModal from '../loans/EditConsumerModal'
import ModalTrigger from '../../common/modals/ModalTrigger'
import { checkPermission } from '../../common/utils/helpers'

const ConsumerEditButton = ({
  consumer,
  loanData,
  loan,
  refreshOrder,
  setLoader,
  current_veteran,
  current_primary_obligor,
}) => {
  if (!checkPermission('consumer_edit')) {
    return null
  }

  return (
    <ModalTrigger
      component={EditConsumerModal}
      modalClassName="modal-primary"
      consumer={consumer}
      loan_id={loanData.id}
      setLoader={setLoader}
      refetch={loan ? loan.fetch : refreshOrder}
      is_va_consumer={loanData.is_va_loan}
      disable_select_veteran={
        current_veteran && current_veteran !== consumer.id
      }
      disable_select_primary_obligor={
        current_primary_obligor &&
        current_primary_obligor !== consumer.id
      }
    >
      <a href="#">Edit</a>
    </ModalTrigger>
  )
}

export default ConsumerEditButton
